import { ListActionsAndIssuesGraphResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { ActionsChartModel } from '~/pages/Metrics/models/ActionsChartModel';
import { IssuesChartModel } from '~/pages/Metrics/models/IssuesChartModel';

export class SystemBehaviourModel {
  actionsChart: ActionsChartModel;

  issuesChart: IssuesChartModel;

  constructor(response: ListActionsAndIssuesGraphResponse) {
    this.actionsChart = new ActionsChartModel(response.actionLanes);
    this.issuesChart = new IssuesChartModel(response.issueLanes);
  }
}
